import React, { useEffect } from 'react';

import LoadingSpinner from 'dpl/components/LoadingSpinner';
import { ANALYTICS_VIEWS } from 'dpl/constants/analytics';
import { setAnalyticsOrigin } from 'dpl/shared/utils/setAnalyticsOrigin';

import { usePuppyData } from '../hooks/usePuppyData';
import ActionBar from './ActionBar';
import GettingPuppyHome from './GettingPuppyHome';
import GetToKnowPuppy from './GetToKnowPuppy';
import IconSet from './IconSet';
import MeetPuppyBreeder from './MeetPuppyBreeder';
import OwnerStories from './OwnerStories';
import PageHeader from './PageHeader';
import PuppyDetails from './PuppyDetails';
import PuppyParents from './PuppyParents';
import PuppySiblings from './PuppySiblings';
import LitterUpdates from './LitterUpdates';

export default function Layout() {
  const { isValid, isFetching } = usePuppyData();

  useEffect(() => {
    setAnalyticsOrigin({
      originView: ANALYTICS_VIEWS.PUPPY_PROFILE
    });
  }, []);

  useEffect(() => {
    const footer = document.querySelector('body > footer');

    if (footer && !isFetching) {
      footer.style.display = 'block';
    }
  }, [isFetching]);

  if (!isValid && !isFetching) {
    return (
      <div className="Layout">
        <h1>Puppy not found</h1>
      </div>
    );
  }

  if (isFetching) {
    return (
      <div className="Layout Layout--loading">
        <LoadingSpinner className="self-center" />
      </div>
    );
  }

  return (
    <div className="Layout">
      <PageHeader />
      <ActionBar />
      <PuppyDetails />
      <PuppyParents />
      <GetToKnowPuppy />
      <GettingPuppyHome />
      <MeetPuppyBreeder />
      <OwnerStories />
      <LitterUpdates />
      <PuppySiblings />
      <IconSet />
    </div>
  );
}
